// src/pages/Settings/tabs/PaymentDetailsTab.js
import React, { useState } from 'react';
import { useProfile } from '../../../context/ProfileContext';
import { useStripe } from '@stripe/react-stripe-js';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import PaymentDetailsSettings from '../../../components/userDashboard/PaymentDetailsSettings';

const PREMIUM_PRICE_ID = 'price_1S1RH1Ba2po33Pi0sfD8uk3I'; // 👈 Ensure your Price ID is here

const PaymentDetailsTab = () => {
    const { user, userProfile } = useProfile();
    const stripe = useStripe();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="space-y-8 animate-in slide-in-from-bottom-4 duration-500">
            <header>
                <h2 className="text-xl font-black uppercase tracking-tight dark:text-white">Payments & Billing</h2>
                <p className="text-sm text-slate-500">Manage your saved credit cards and billing methods.</p>
            </header>

            {/* --- SECTION 1: CARD MANAGEMENT --- */}
            <div className="payment-settings-wrapper">
                <PaymentDetailsSettings />
            </div>

            <hr className="border-slate-100 dark:border-slate-800" />

            <p className="text-[10px] text-slate-400 text-center pb-10">
                Payments secured by Stripe. Manage or cancel anytime.
            </p>
        </div>
    );
};

export default PaymentDetailsTab;